var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D2D",
    d: "m9.125 18.313.938-.938a.583.583 0 0 0-.047-.797l-3.75-3.61H22.39a.57.57 0 0 0 .562-.562v-1.312a.54.54 0 0 0-.562-.563H6.266l3.75-3.656a.583.583 0 0 0 .046-.797l-.937-.937a.635.635 0 0 0-.797 0l-6.187 6.187a.635.635 0 0 0 0 .797l6.187 6.188a.635.635 0 0 0 .797 0"
  })));
};
export default SvgArrowLeft;